define('views/breadcrumb',['require','views/base/view','text!templates/breadcrumb.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        template = require('text!templates/breadcrumb.ejs');

    var BreadcrumbView = View.extend({
        autoRender: true,
        tagName: 'ul',
        className: 'breadcrumb',
        region: 'breadcrumb',
        id: 'breadcrumb',
        template: template,
        listen: {
            'change:items model': 'render'
        }
    });
    return BreadcrumbView;
});
